import CsvTransformer from "./CsvTransformer"
import { safeNull } from "../../common/Util"
import moment from "moment-timezone"
import Region from "../Region"

export default class RegionsCsvTransformer extends CsvTransformer<Region> {
  get filename () {
    return `regions-${moment().format('YYYYMMDD')}.csv`
  }

  constructor () {
    super()

    this.addColumn({
      header: 'id',
      valueTransformer: row => String(row.id),
    })

    this.addColumn({
      header: 'Region Name',
      valueTransformer: row => safeNull(() => row.name) || '',
    })

    this.addColumn({
      header: 'Areas',
      valueTransformer: row => safeNull(() => row.numberOfAreas) || '',
    })

    this.addColumn({
      header: 'Chapters',
      valueTransformer: row => safeNull(() => row.numberOfChapters) || '',
    })

    this.addColumn({
      header: 'Members',
      valueTransformer: row => safeNull(() => row.numberOfMembers) || '',
    })
  }
}